/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PjErrorInfo } from '../../common/extends_fw/service/PjErrorInfo';
import { PjBaseService } from '../../common/extends_fw/service/PjBaseService';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { HeaderApi } from '../api/HeaderApi';
import { UserEditJson } from '../json/JsonAll';

/**
 * パスワード情報を管理する。
 */
export class HeaderService extends PjBaseService {

    /**
     * コンストラクタ
     * @param {ng.IQService} $q 非同期サービス
     * @param {AuthorApi} authorApi 著者API
     */
    /* @ngInject */
    public constructor(protected $q: ng.IQService,
            protected headerApi: HeaderApi) {
        super(null);
    }

    /**
     * ログアウト
     */
    public logout(): ng.IPromise<UserEditJson> {
        return this.headerApi.logout().then((data: UserEditJson) => {
            return data;
        });
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/service/HeaderService.ts
 **/